import { render, staticRenderFns } from "./SystemInformation.vue?vue&type=template&id=6c521304&"
import script from "./SystemInformation.vue?vue&type=script&lang=ts&"
export * from "./SystemInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports